export default {
    // 通用标签
    tags: {
        method: "get",
        url: "/common/tags"
    },
    // 配置
    configs: {
        method: "get",
        url: "/configs"
    },
    // 验证码图片
    captcha: {
        method: "get",
        url: "/captcha"
    },
    // 文件上传
    uploadFile: {
        method: "post",
        url: "/common/upload/files"
    },
    // 多文件上传
    uploadFilesMulti: {
        method: "post",
        url: "/common/upload/files/multi"
    },
    // 区域列表
    areas: {
        method: "get",
        url: "/common/areas"
    },
    // 营业执照识别
    ocrBusinessLicense: {
        method: "post",
        url: "/ocr_business_license"
    }
};


// WEBPACK FOOTER //
// ./src/api/common.js